import { canUpdate } from './validators/functions/can-update.function';

export * from './enums/reservation-checkout-mode.enum';
export * from './enums/reservation-payment-amount.enum';
export * from './enums/percentage-deposit-rounding-mode.enum';
export * from './consts/default-percentage-deposit-rounding.const';
export * from './interfaces/percentage-deposit-rounding-config.interface';
export * from './dtos/tenant-settings-discounts.dto';
export * from './dtos/tenant-settings-e-signatures.dto';
export * from './dtos/tenant-settings-gps-trackers.dto';
export * from './dtos/tenant-settings-integrations-saferpay.dto';
export * from './dtos/tenant-settings-integrations-track-solid.dto';
export * from './dtos/tenant-settings-integrations.dto';
export * from './dtos/tenant-settings-payment-providers.dto';
export * from './dtos/tenant-settings-public-e-signatures.dto';
export * from './dtos/tenant-settings-public-gps-trackers.dto';
export * from './dtos/tenant-settings-public-integrations-saferpay.dto';
export * from './dtos/tenant-settings-public-integrations-track-solid.dto';
export * from './dtos/tenant-settings-public-integrations.dto';
export * from './dtos/tenant-settings-public-payment-providers.dto';
export * from './dtos/tenant-settings-reports.dto';
export * from './dtos/tenant-settings-reservation-percentage-deposit-rounding.dto';
export * from './dtos/tenant-settings.dto';
export * from './dtos/update-tenant-settings.dto';

export const tenantSettingsValidators = { canUpdate };
